export const NEWS_BRIEFING_TITLE_BUTTON_CLASS_NAME = 'w-full text-left text-gr-800 Body5M14';
